var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestionCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 147,
    viewBox: "0 0 140 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.248 55.1387C62.2758 52.0708 64.3045 49.4839 66.9748 47.8361C69.645 46.1883 72.7845 45.5859 75.8372 46.1357C78.8899 46.6855 81.6588 48.352 83.6535 50.84C85.6481 53.328 86.7398 56.4769 86.7352 59.729C86.7352 68.9097 73.62 73.5 73.62 73.5M73.7891 91.875H73.8474M72.9146 122.5C100.299 122.5 122.498 99.1908 122.498 70.4375C122.498 41.6842 100.299 18.375 72.9146 18.375C45.5305 18.375 23.3313 41.6842 23.3313 70.4375C23.3313 76.2562 24.2404 81.852 25.9176 87.0768C26.5488 89.0429 26.8644 90.026 26.9213 90.7812C26.9775 91.5271 26.935 92.05 26.7593 92.7751C26.5813 93.5093 26.1885 94.2728 25.4027 95.8L15.8614 114.344C14.5004 116.989 13.8199 118.311 13.9722 119.332C14.1048 120.221 14.6032 121.004 15.3348 121.472C16.1748 122.01 17.5989 121.856 20.447 121.547L50.3196 118.304C51.2242 118.206 51.6765 118.157 52.0888 118.174C52.4943 118.19 52.7806 118.23 53.176 118.326C53.578 118.423 54.0836 118.628 55.0947 119.037C60.625 121.274 66.6334 122.5 72.9146 122.5Z",
    stroke: "#1F2C3A",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestionCircle1);
export default __webpack_public_path__ + "static/media/message-question-circle (1).f48f28403975dc6bb98b095fbc0115da.svg";
export { ForwardRef as ReactComponent };